/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Saveandpublish2Inputs */

const en_saveandpublish2 = /** @type {(inputs: Saveandpublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const de_saveandpublish2 = /** @type {(inputs: Saveandpublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Saveandpublish2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const saveandpublish2 = /** @type {((inputs?: Saveandpublish2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saveandpublish2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saveandpublish2(inputs)
	return de_saveandpublish2(inputs)
});
export { saveandpublish2 as "saveAndPublish" }